var vO474 = {
  single_source_shortest_paths: function (p18345, p18346, p18347) {
    var vO475 = {};
    var vO476 = {
      [p18346]: 0
    };
    var v14082 = vO474.PriorityQueue.make();
    v14082.push(p18346, 0);
    var v14083;
    var v14084;
    var v14085;
    var v14086;
    var v14087;
    var v14088;
    var v14089;
    var v14090;
    var v14091;
    for (; !v14082.empty();) {
      v14083 = v14082.pop();
      v14084 = v14083.value;
      v14086 = v14083.cost;
      v14087 = p18345[v14084] || {};
      for (v14085 in v14087) {
        if (v14087.hasOwnProperty(v14085)) {
          v14088 = v14087[v14085];
          v14089 = v14086 + v14088;
          v14090 = vO476[v14085];
          v14091 = typeof vO476[v14085] == "undefined";
          if (v14091 || v14090 > v14089) {
            vO476[v14085] = v14089;
            v14082.push(v14085, v14089);
            vO475[v14085] = v14084;
          }
        }
      }
    }
    if (typeof p18347 != "undefined" && typeof vO476[p18347] == "undefined") {
      var v14092 = ["Could not find a path from ", p18346, " to ", p18347, "."].join("");
      throw new Error(v14092);
    }
    return vO475;
  },
  extract_shortest_path_from_predecessor_list: function (p18348, p18349) {
    var v14093;
    var vA796 = [];
    for (var vP18349 = p18349; vP18349;) {
      vA796.push(vP18349);
      v14093 = p18348[vP18349];
      vP18349 = p18348[vP18349];
    }
    vA796.reverse();
    return vA796;
  },
  find_path: function (p18350, p18351, p18352) {
    var v14094 = vO474.single_source_shortest_paths(p18350, p18351, p18352);
    return vO474.extract_shortest_path_from_predecessor_list(v14094, p18352);
  },
  PriorityQueue: {
    make: function (p18353) {
      var v14095;
      var v14096 = vO474.PriorityQueue;
      var vO477 = {};
      p18353 = p18353 || {};
      for (v14095 in v14096) {
        if (v14096.hasOwnProperty(v14095)) {
          vO477[v14095] = v14096[v14095];
        }
      }
      vO477.queue = [];
      vO477.sorter = p18353.sorter || v14096.default_sorter;
      return vO477;
    },
    default_sorter: function (p18354, p18355) {
      return p18354.cost - p18355.cost;
    },
    push: function (p18356, p18357) {
      this.queue.push({
        value: p18356,
        cost: p18357
      });
      this.queue.sort(this.sorter);
    },
    pop: function () {
      return this.queue.shift();
    },
    empty: function () {
      return this.queue.length === 0;
    }
  }
};
if (true) {
  module.exports = vO474;
}